/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Sugg_CancelInputs */

const cs_addr_sugg_cancel = /** @type {(inputs: Addr_Sugg_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrušit`)
};

const en_addr_sugg_cancel = /** @type {(inputs: Addr_Sugg_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Addr_Sugg_CancelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_sugg_cancel = /** @type {((inputs?: Addr_Sugg_CancelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Sugg_CancelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_sugg_cancel(inputs)
	return cs_addr_sugg_cancel(inputs)
});